import React from "react";
import PropTypes from "prop-types";
import { NavLink as RouteNavLink, useLocation } from "react-router-dom";
import { NavItem, NavLink } from "shards-react";

// Custom styles that will be applied to active items
const customActiveStyle = {
  backgroundColor: 'rgba(33, 170, 115, 0.2)',
  color: '#21AA73',
  fontWeight: '600',
  borderLeft: '6px solid rgba(25, 128, 86, 0.95)',
  boxShadow: '0 0 0 1px rgba(33, 170, 115, 0.2)'
};

const SidebarNavItem = ({ item }) => {
  const location = useLocation();
  
  // Check if this nav item should be active based on various conditions
  const isActive = 
    location.pathname === item.to || 
    (item.to === "/citations" && location.pathname.includes("/citation/")) ||
    (item.to === "/locations" && location.pathname.includes("/add-location"));
  
  // Apply active class and styles conditionally
  const linkClassName = isActive ? "active custom-active-nav" : "";
  const linkStyle = isActive ? customActiveStyle : {};

  return (
    <NavItem>
      <NavLink 
        tag={RouteNavLink} 
        to={item.to} 
        className={linkClassName}
        style={linkStyle}
      >
        {item.htmlBefore && (
          <div
            className="d-inline-block item-icon-wrapper"
            dangerouslySetInnerHTML={{ __html: item.htmlBefore }}
          />
        )}
        {item.title && <span>{item.title}</span>}
        {item.htmlAfter && (
          <div
            className="d-inline-block item-icon-wrapper"
            dangerouslySetInnerHTML={{ __html: item.htmlAfter }}
          />
        )}
      </NavLink>
    </NavItem>
  );
};

SidebarNavItem.propTypes = {
  /**
   * The item object.
   */
  item: PropTypes.object
};

export default SidebarNavItem;
